import React, { Suspense, useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Slider = React.lazy(() => import("react-slick"));
const imageDimensions = {
  "/assets/images/banner-slider-image1.webp": { width: 1920, height: 800 },
  "/assets/images/banner-slider-image2.webp": { width: 1920, height: 800 },
  "/assets/images/banner-right-image1.webp": { width: 874, height: 721 },
  "/assets/images/banner-right-image2.webp": { width: 862, height: 640 },
  "/assets/images/first-banner-image1.webp": { width: 341, height: 311 },
  "/assets/images/first-banner-image2.webp": { width: 284, height: 257 },
  "/assets/images/first-banner-image3.webp": { width: 242, height: 185 },
  "/assets/images/first-banner-image4.webp": { width: 639, height: 619 },
  "/assets/images/second-banner-image1.webp": { width: 283, height: 214 },
  "/assets/images/second-banner-image2.webp": { width: 270, height: 217 },
  "/assets/images/second-banner-image3.webp": { width: 264, height: 138 },
  "/assets/images/second-banner-image4.webp": { width: 641, height: 492 },
  "/assets/images/second-banner-image5.webp": { width: 197, height: 104 },
};

const dimensionsFor = (src) => imageDimensions[src] || {};
const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5000,
  speed: 2000,
  cssEase: "ease",
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: { slidesToShow: 1 },
    },
    {
      breakpoint: 767,
      settings: { slidesToShow: 1 },
    },
  ],
};
export default function BannerSlider({ slides = [], extraClass = "" }) {
  const [sliderReady, setSliderReady] = useState(false);

  useEffect(() => {
    let idleId;
    let timerId;

    const activateSlider = () => setSliderReady(true);
    const scheduleSlider = () => {
      if ("requestIdleCallback" in window) {
        idleId = window.requestIdleCallback(activateSlider, { timeout: 2000 });
      } else {
        timerId = window.setTimeout(activateSlider, 1000);
      }
    };

    if (document.readyState === "complete") scheduleSlider();
    else window.addEventListener("load", scheduleSlider, { once: true });

    return () => {
      window.removeEventListener("load", scheduleSlider);
      if (idleId) window.cancelIdleCallback(idleId);
      if (timerId) window.clearTimeout(timerId);
    };
  }, []);

  const renderSlide = (slide, index) => (
    <div className="banner-col" key={index}>
      <div className="banner-inner">
        <img
          src={slide?.bgImage}
          {...dimensionsFor(slide?.bgImage)}
          alt={slide?.altText}
          className="img-responsive"
          fetchpriority={index === 0 ? "high" : "auto"}
          loading={index === 0 ? "eager" : "lazy"}
        />
        <div className="container banner-content">
          <div className="banner-content-inner">
            <div className="row content-inner align-items-center">
              <div className="col-sm-7 col-md-7 col-lg-6">
                <div className="content-wrapper">
                  {slide?.subtitle && (<div className="subtitle" dangerouslySetInnerHTML={{ __html: slide?.subtitle }}></div>)}
                  {slide?.title && (<div className="heading" dangerouslySetInnerHTML={{ __html: slide?.title }}></div>)}
                  {slide?.description && (<p dangerouslySetInnerHTML={{ __html: slide?.description }}></p>)}
                  {slide?.buttonText && (<Link to={slide?.link} className="theme-btn"><span>{slide?.buttonText}</span></Link>)}
                </div>
              </div>
              <div className="col-sm-5 col-md-5 col-lg-6">
                <div className="image-wrapper-inner">
                  <div className="image-wrapper">
                    {slide?.rightImage && (<img src={slide?.rightImage} {...dimensionsFor(slide?.rightImage)} alt={slide?.altText} className={`img-responsive ${slide?.className || ""}`} />)}
                  </div>
                  {slide?.vectorImages?.map((img, i) => (
                    <img key={i} src={img?.src} {...dimensionsFor(img?.src)} alt={`vector-${i}`} className={`animation-img img-responsive ${img?.className || ""}`} />
                  ))}
                </div>
                <div className="mobile-banner-image">
                  {slide?.mobileImage && (<img src={slide?.mobileImage} {...dimensionsFor(slide?.mobileImage)} alt={slide?.altText} className="img-responsive" />)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const staticBanner = slides[0] ? renderSlide(slides[0], 0) : null;

  return (
    <section className={`banner-section ${extraClass}`}>
      <div className="theme-banner-slider">
        {sliderReady ? (
          <Suspense fallback={staticBanner}>
            <Slider {...settings}>{slides?.map(renderSlide)}</Slider>
          </Suspense>
        ) : staticBanner}
      </div>
    </section>
  );
}
